import { Tab, Tabs, TabsProps } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useApartment } from "../../../graphql/hooks";
import { Apartment } from "../../../graphql/models";
import { LoadWrapper } from "../load_wrapper";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

export type ApartmentsTabsProps = {
  buildingId?: string;
  TabContentComponent: React.FC<{
    apartment: Apartment;
  }>;
} & Omit<TabsProps, "value" | "onChange">;
export function ApartmentsTabs(props: ApartmentsTabsProps) {
  const { buildingId, TabContentComponent, ...tabsProps } = props;

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const {
    fetchApartmentsList,
    apartmentsList,
    apartmentsListError,
    apartmentsListLoading,
  } = useApartment();

  useEffect(() => {
    fetchApartmentsList({
      variables: {
        buildingId,
      },
    });
  }, [buildingId, fetchApartmentsList]);

  return (
    <>
      <LoadWrapper loading={apartmentsListLoading} error={apartmentsListError}>
        <Tabs
          value={selectedTabIndex}
          onChange={(e, idx) => setSelectedTabIndex(idx)}
          indicatorColor="primary"
          textColor="primary"
          {...tabsProps}
        >
          {apartmentsList.map((apartment, idx) => (
            <Tab tabIndex={idx} label={apartment.code} />
          ))}
        </Tabs>
      </LoadWrapper>
      {apartmentsList.map((apartment, idx) => (
        <TabPanel value={selectedTabIndex} index={idx}>
          <TabContentComponent apartment={apartment} />
        </TabPanel>
      ))}
    </>
  );
}
